import { useCallback, useMemo, useState, type ReactNode } from 'react';
import { useTablePreferences } from '@/application/container';
import { useFinanceSettings } from '@/application/usecases/useFinance';
import { MoneyChoiceProvider } from '@/ui/money/moneyView';

/** Where this device remembers the choice. */
const IN_DOLLARS = 'money.inDollars';

/**
 * How every screen of this device reads amounts: in dirhams, the system's
 * money, or in dollars at the rate Accounts set. The lab's request of
 * 17 October 2026, item 13. A habit of the device, as the vibration on
 * confirmations is, and nothing anybody else sees.
 *
 * The rate is asked for only once dollars are chosen: a screen in dirhams
 * needs nothing from the server to say an amount.
 */
export function MoneyViewProvider({ children }: { children: ReactNode }) {
  const preferences = useTablePreferences();
  const [inDollars, setInDollars] = useState(() => preferences.setting(IN_DOLLARS) === true);
  const settings = useFinanceSettings(inDollars);
  const rate = settings.data?.usdRate ?? null;

  const choose = useCallback(
    (on: boolean) => {
      setInDollars(on);
      preferences.rememberSetting(IN_DOLLARS, on);
    },
    [preferences],
  );

  const value = useMemo(() => ({ inDollars, rate, choose }), [inDollars, rate, choose]);
  return <MoneyChoiceProvider value={value}>{children}</MoneyChoiceProvider>;
}
